export default __webpack_public_path__ + "static/media/magnifying-glass.64e5cf02.svg";